import { ChangeEvent, useState } from "react";
import { useTranslation } from 'react-i18next';

interface Props {
  search: string;
  setSearch: (term: string) => void;
  className?: string;
}

const SearchBar = ({ search, setSearch, className }: Props) => {
  const { t } = useTranslation();
  const tBase = "components.glass";
  const tr = (key: string) => t(`${tBase}.${key}`);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value);
  };

  return (
    <div className={className}>
      <div className="relative flex items-center bg-white bg-opacity-20 rounded-md border py-1">
        <span className="text-gray-600 pb-1">
          <svg
            className="w-6 h-6"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M21 21l-4.35-4.35"
            />
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M15.5 10.5a5 5 0 11-7.07 0 5 5 0 017.07 0z"
            />
          </svg>
        </span>
        <input
          className="pl-2 pr-4 w-full bg-transparent text-gray-900 focus:outline-none"
          type="search"
          placeholder={tr("Search")}
          value={search}
          onChange={handleChange}
        />
      </div>
    </div>
  );
};

export { SearchBar };
